import { SpawnRegistry } from '../spawn.js';
import { registerBerserkSpawns } from './berserk.js';
import { registerBoss2Spawns } from './boss2.js';
import { registerBrainSpawns } from './brain.js';
import { registerChickSpawns } from './chick.js';
import { registerFlipperSpawns } from './flipper.js';
import { registerFloaterSpawns } from './floater.js';
import { registerFlyerSpawns } from './flyer.js';
import { registerGladiatorSpawns } from './gladiator.js';
import { registerGunnerSpawns } from './gunner.js';
import { registerHoverSpawns } from './hover.js';
import { registerIcarusSpawns } from './icarus.js';
import { registerInfantrySpawns } from './infantry.js';
import { registerJorgSpawns } from './jorg.js';
import { registerInsaneSpawns } from './insane.js';
import { registerActorSpawns } from './actor.js';
import { registerMakronSpawns } from './makron.js';
import { registerMedicSpawns } from './medic.js';
import { registerMutantSpawns } from './mutant.js';
import { registerParasiteSpawns } from './parasite.js';
import { registerMonsterSpawns as registerSoldierSpawns } from './soldier.js';
import { registerSupertankSpawns } from './supertank.js';
import { registerTankSpawns } from './tank.js';
import { registerTankCommanderSpawns } from './tankCommander.js';
import { registerTurretSpawns } from './turret.js';
import { registerGekkSpawns } from './gekk.js';
import { registerFixbotSpawns } from './fixbot.js';
import { registerArachnidSpawns } from './arachnid.js';
import { registerGunCommanderSpawns } from './gunnerCommander.js';
import { registerGuardianSpawns } from './guardian.js';
import { registerStalkerSpawns } from './rogue/stalker.js';
import { registerShamblerSpawns } from './shambler.js';
import { registerWidow } from './rogue/widow.js';

export function registerMonsterSpawns(registry: SpawnRegistry): void {
  registerSoldierSpawns(registry);
  registerGunnerSpawns(registry);
  registerBerserkSpawns(registry);
  registerGladiatorSpawns(registry);
  registerMedicSpawns(registry);
  registerMutantSpawns(registry);
  registerParasiteSpawns(registry);
  registerTankSpawns(registry);
  registerTankCommanderSpawns(registry);
  registerTurretSpawns(registry);
  registerBrainSpawns(registry);
  registerFlipperSpawns(registry);
  registerChickSpawns(registry);
  registerIcarusSpawns(registry);
  registerFlyerSpawns(registry);
  registerFloaterSpawns(registry);
  registerHoverSpawns(registry);
  registerInfantrySpawns(registry);
  registerSupertankSpawns(registry);
  registerBoss2Spawns(registry);
  registerJorgSpawns(registry);
  registerMakronSpawns(registry);
  registerInsaneSpawns(registry);
  registerActorSpawns(registry);
  registerGekkSpawns(registry);
  registerFixbotSpawns(registry);
  registerArachnidSpawns(registry);
  registerGunCommanderSpawns(registry);
  registerGuardianSpawns(registry);
  registerStalkerSpawns(registry);
  registerShamblerSpawns(registry);
  registerWidow(registry);
}
